import { PageLandingPage } from '@pages/landing-page';
import { history } from 'asumsi-components';
import React from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { PageLandingPageDetail } from '@pages/landing-page-form';
import { PageDashboard } from "@pages/dashboard";
import { PageLogin } from '@pages/login';
import { clearAllCookie, isLogin } from '@helpers/cookies';
import { PageTopics } from '@pages/topics';
import { PageTopicsDetail } from '@pages/topics-form';
import { PageNewsCrawler } from '@pages/news-crawler';
import { ValidateToken } from '@utils/fetch-data';
import { PageRoles } from "@pages/roles";
import { PageRolesDetail } from "@pages/roles-form";
import { PageRoleGroups } from "@pages/role-groups";
import { PageRoleGroupsDetail } from "@pages/role-groups-form";
import { PagePost } from '@pages/post';
import { PagePostDetail } from '@pages/post-form';
import { PageUsers } from '@pages/users';
import { PageUsersDetail } from '@pages/users-form';
import { PageStatics } from '@pages/statics';
import { PageStaticsDetail } from '@pages/statics-form';
import { PageFooterDetail } from '@pages/footer-form';
import { PageHomePageDetail } from '@pages/homepage-form';
import { PageVideos } from '@pages/videos';
import { PageVideosDetail } from '@pages/videos-form';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  integrations: [
    new Integrations.BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const PublicRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={(props: any) => (!isLogin() ? <Component {...props} /> : <Redirect to="/dashboard" />)}
  />
);

const StrictRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={(props: any) => {
      ValidateToken();
      if (isLogin()) {
        return <Component {...props} />;
      } else {
        clearAllCookie();
        return <Redirect to="/" />
      }
    }}
  />
);

export const AppRouter = () => {
  return (
    <Router history={history}>
      <Switch>
        <PublicRoute exact={true} path="/" component={PageLogin} />
        <PublicRoute exact={true} path="/login" component={PageLogin} />
        <StrictRoute exact={true} path="/dashboard" component={PageDashboard} />
        <StrictRoute exact={true} path="/article/landing-page" component={PageLandingPage} />
        <StrictRoute exact={true} path="/article/landing-page/form" component={PageLandingPageDetail} />
        <StrictRoute exact={true} path="/article/landing-page/form/:id" component={PageLandingPageDetail} />
        <StrictRoute exact={true} path="/article/news-crawler" component={PageNewsCrawler} />
        <StrictRoute exact={true} path="/article/topics" component={PageTopics} />
        <StrictRoute exact={true} path="/article/topics/form" component={PageTopicsDetail} />
        <StrictRoute exact={true} path="/article/topics/form/:id" component={PageTopicsDetail} />
        <StrictRoute exact={true} path="/article/videos" component={PageVideos} />
        <StrictRoute exact={true} path="/article/videos/form/:id" component={PageVideosDetail} />
        <StrictRoute exact={true} path="/user/roles" component={PageRoles} />
        <StrictRoute exact={true} path="/user/roles/form" component={PageRolesDetail} />
        <StrictRoute exact={true} path="/user/roles/form/:id" component={PageRolesDetail} />
        <StrictRoute exact={true} path="/user/role-groups" component={PageRoleGroups} />
        <StrictRoute exact={true} path="/user/role-groups/form" component={PageRoleGroupsDetail} />
        <StrictRoute exact={true} path="/user/role-groups/form/:id" component={PageRoleGroupsDetail} />
        <StrictRoute exact={true} path="/article/posts" component={PagePost} />
        <StrictRoute exact={true} path="/article/posts/form" component={PagePostDetail} />
        <StrictRoute exact={true} path="/article/posts/form/:id" component={PagePostDetail} />
        <StrictRoute exact={true} path="/user/users" component={PageUsers} />
        <StrictRoute exact={true} path="/user/users/form" component={PageUsersDetail} />
        <StrictRoute exact={true} path="/user/users/form/:id" component={PageUsersDetail} />
        <StrictRoute exact={true} path="/settings/statics" component={PageStatics} />
        <StrictRoute exact={true} path="/settings/statics/form" component={PageStaticsDetail} />
        <StrictRoute exact={true} path="/settings/statics/form/:id" component={PageStaticsDetail} />
        <StrictRoute exact={true} path="/settings/footer" component={PageFooterDetail} />
        <StrictRoute exact={true} path="/settings/home-page" component={PageHomePageDetail} />
        <Redirect from="*" to={'/'} />
      </Switch>
    </Router>
  );
};

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routes/index.tsx